import './StatsChart.scss'

import { useEffect, useMemo, useRef, useState } from 'react'
import { useChartGroupContext } from './ChartGroup'

import Chart from 'chart.js/auto'
import 'chartjs-adapter-luxon'

import { Spinner } from '@blueprintjs/core'
import { DateTime } from 'luxon'
import Lang from '../../../../../../../Lang'

export default function StatsChart({ label, data, loading }) {
	const { curDate } = useChartGroupContext()

	const [empty, setEmpty] = useState(false)

	const chartRef = useRef(null)
	const chartCanvasRef = useRef(null)

	const labels = useMemo(() => {
		return [...Array(24)].map((d, idx) => idx * 3600000 + curDate.valueOf())
	}, [])

	useEffect(() => {
		if (!data) return

		// izfiltree to, kas nav tagad
		setEmpty(data.length === 0 || (data.every((v) => v === undefined) && data.length > 0))

		const points = data

		if (chartRef.current) {
			chartRef.current.data.labels = labels
			chartRef.current.data.datasets[0].data = points
			chartRef.current.update()
			return
		}

		chartRef.current = new Chart(chartCanvasRef.current, {
			type: 'line',
			options: {
				responsive: true,
				animation: {
					duration: 0
				},
				plugins: {
					legend: {
						display: false
					},
					tooltip: {
						usePointStyle: true,
						callbacks: {
							title: (context) => {
								const t = DateTime.fromMillis(context[0].parsed.x)
								return t.toFormat('HH:mm')
							}
						}
					}
				},
				scales: {
					y: {
						min: 0
					},
					x: {
						type: 'time',
						time: {
							unit: 'hour',
							displayFormats: {
								hour: 'HH:mm'
							}
						}
					}
				}
			},
			data: {
				labels: labels,
				datasets: [
					{
						label: label,
						data: points,
						backgroundColor: '#67CC7177',
						fill: true,
						borderColor: '#67CC71',
						inflateAmount: 1
					}
				]
			}
		})
	}, [curDate, data])

	return (
		<div className={`statsChart`}>
			<canvas className="chart" ref={chartCanvasRef} />
			{loading && <Spinner className="spinner" />}
			{!loading && empty && <span className="no-data">{Lang.get('No data')}</span>}
		</div>
	)
}
